export function reserveEmphasisWidth(label: HTMLElement): void {
  // Measure rich labels at the selected weight without leaving duplicate text or ids in the DOM.
  const copy = label.cloneNode(true) as HTMLElement;
  copy.removeAttribute("id");
  copy.querySelectorAll("[id]").forEach((node) => node.removeAttribute("id"));
  copy.setAttribute("aria-hidden", "true");
  Object.assign(copy.style, {
    position: "absolute",
    visibility: "hidden",
    pointerEvents: "none",
    fontWeight: "600",
    minWidth: "0",
    width: "max-content",
    maxWidth: "none",
  });
  label.parentElement?.append(copy);
  const measured = Number.parseFloat(getComputedStyle(copy).width);
  const width = Number.isFinite(measured) ? measured : copy.offsetWidth;
  copy.remove();
  if (width > 0 && label.style.minWidth !== `${width}px`) label.style.minWidth = `${width}px`;
}
